<template>
  <model-report-component></model-report-component>
</template>
<script>
import ModelReportComponent from '@/components/ModelReportComponent.vue'
export default {
  components: {
    ModelReportComponent
  }
}
</script>
